import { getItemFromCollection } from "directus/src/operations";

export async function fetchjobTitleData({ jobtitleId }) {
  try {
    const response = await getItemFromCollection("job_titles", jobtitleId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
